import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/item-tag');
};

const find = (code) => {
	return Client.get(`/admin/api/item-tag/${code}`);
};

const create = (payload) => {
	return Client.post('/admin/api/item-tag', payload);
};

const update = (code, payload) => {
	return Client.put(`/admin/api/item-tag/${code}`, payload);
};

const remove = (code) => {
	return Client.del(`/admin/api/item-tag/${code}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
